import items from "../../../../src/data/components/dropdown.js";
import React from 'react';
export default {
  items,
  React
};